import styled from 'styled-components'

export const StyledMyPageYourCommentsModal = styled.div``
